import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	unresolvedIssuesHeader: {
		id: 'project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-header',
		defaultMessage: 'Unresolved {issues, plural, one {issue} other {issues}}',
		description: '',
	},
	unresolvedIssuesMove: {
		id: 'project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-move',
		defaultMessage: 'Move unresolved {issues, plural, one {issue} other {issues}} to',
		description: '',
	},
	unresolvedIssuesIgnore: {
		id: 'project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-ignore',
		defaultMessage: 'Ignore unresolved issues',
		description: '',
	},
	invalidVersionChosen: {
		id: 'project-directories.versions.release-version-modal.content.swap-issues.invalid-version-chosen',
		defaultMessage:
			"Can't use this version. Change this version to another in your project or remove it from {issues, plural, one {this issue} other {these issues}}.",
		description: '',
	},
	unresolvedIssuesHeaderIssueTermRefresh: {
		id: 'project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-header-issue-term-refresh',
		defaultMessage: 'Unresolved {issues, plural, one {work item} other {work items}}',
		description: '',
	},
	unresolvedIssuesMoveIssueTermRefresh: {
		id: 'project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-move-issue-term-refresh',
		defaultMessage: 'Move unresolved {issues, plural, one {work item} other {work items}} to',
		description: '',
	},
	unresolvedIssuesIgnoreIssueTermRefresh: {
		id: 'project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-ignore-issue-term-refresh',
		defaultMessage: 'Ignore unresolved work items',
		description: '',
	},
	invalidVersionChosenIssueTermRefresh: {
		id: 'project-directories.versions.release-version-modal.content.swap-issues.invalid-version-chosen-issue-term-refresh',
		defaultMessage:
			"Can't use this version. Change this version to another in your project or remove it from {issues, plural, one {this work item} other {these work items}}.",
		description: '',
	},
});
